import {
  Directive,
  HostBinding,
  inject,
  Input,
  OnChanges,
} from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { SvgIcon } from './create-icon-definition';

@Directive({
  selector: '[h3CustomIcon]',
  standalone: true,
})
export class CustomIconDirective implements OnChanges {
  @Input() h3CustomIcon?: Omit<SvgIcon, 'svg'>;
  @HostBinding('style.width') width?: string;
  @HostBinding('style.height') height?: string;

  private matIcon = inject(MatIcon);

  ngOnChanges() {
    if (!this.h3CustomIcon) {
      return;
    }
    this.matIcon.svgIcon = this.h3CustomIcon.name;
    this.matIcon.inline = true;

    if (this.h3CustomIcon.width) {
      this.width = this.h3CustomIcon.width;
    }
    if (this.h3CustomIcon.height) {
      this.height = this.h3CustomIcon.height;
    }
  }
}
